module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./BrowseDetailView.js"));
	}, "BrowseDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BrowseDetailView!./src/pages/Store/BusinessManage/RegisterBrowse/BrowseDetail/BrowseDetailView.js
// module id = 1211
// module chunks = 431